import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const planCompare = {
  fetchComparePlans: lazyModuleMethod(
    () => import('./fetchComparePlans'),
    'default'
  ),
  createComparePlan: lazyModuleMethod(
    () => import('./createComparePlan'),
    'default'
  ),
  updateComparePlan: lazyModuleMethod(
    () => import('./updateComparePlan'),
    'default'
  ),
}
